var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.tipContent,"placement":"top"}},[_c('i',{staticClass:"el-icon-question"})])}
var staticRenderFns = []

export { render, staticRenderFns }